import { useState } from 'react';
import { feedPosts } from '@/mocks/gossipData';
import { KIND_TABS, StatusBadge } from './common';

const FALLBACK_FEATURED =
  'https://readdy.ai/api/search-image?query=flat%20minimal%20editorial%20illustration%20of%20newspaper%20clippings%20and%20document%20marks%20on%20warm%20cream%20paper%20with%20red%20vermillion%20slash%20correction%20strokes%20and%20amber%20accents%20ink%20outline%20style%20no%20text%20no%20letters&width=1200&height=675&seq=feed-feature-default&orientation=landscape';

export default function FeedGrid() {
  const [active, setActive] = useState('最新');
  const list = active === '最新' ? feedPosts : feedPosts.filter((p) => p.kind === active);
  const featured = list[0];
  const rest = list.slice(1);

  return (
    <section id="feed" className="w-full scroll-mt-24 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              <span className="text-xs font-bold tracking-widest text-primary-600 uppercase">热点直击</span>
            </div>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">黑料澄清 · 反转真相速览</h2>
            <p className="mt-1.5 text-sm text-foreground-600 md:text-[15px]">
              澄清与实锤对照着看，长短稿混排，抓重点不必翻太久。
            </p>
          </div>
        </div>

        <div className="no-scrollbar mt-6 flex items-center gap-2 overflow-x-auto pb-1">
          {KIND_TABS.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-1 py-1 text-sm font-semibold transition-colors ${
                active === t ? 'text-primary-700' : 'text-foreground-500 hover:text-foreground-800'
              }`}
            >
              <span
                className={`inline-flex items-center gap-1 rounded-full px-3.5 py-1.5 transition-colors ${
                  active === t ? 'bg-primary-500 text-background-50' : ''
                }`}
              >
                {t}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {featured ? (
            <article className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300 sm:col-span-2 lg:col-span-2">
              <div className="relative h-44 w-full overflow-hidden md:h-52">
                <img
                  src={featured.image || FALLBACK_FEATURED}
                  alt={`抖阴黑料 ${featured.kind} 反转真相追踪配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <StatusBadge label={featured.kind} className="!bg-background-50/95" />
                </div>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {featured.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
                <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5"><i className="ri-focus-3-line text-primary-500" /> {featured.source}</span>
                  <span className="inline-flex items-center gap-3">
                    <span>{featured.time}</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {featured.comments}</span>
                  </span>
                </div>
              </div>
            </article>
          ) : null}

          {rest.map((p) => (
            <article key={p.id} className="group flex cursor-pointer flex-col rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-background-300 md:p-5">
              <div className="flex items-center justify-between">
                <StatusBadge label={p.kind} />
                <span className="text-xs text-foreground-400">{p.time}</span>
              </div>
              <h3 className="mt-3 line-clamp-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[17px]">
                {p.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-foreground-600">{p.excerpt}</p>
              <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-2.5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-focus-3-line text-primary-500" /> {p.source}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {p.comments}</span>
              </div>
            </article>
          ))}

          <button
            type="button"
            className="flex min-h-[120px] cursor-pointer items-center justify-center gap-2 rounded-2xl border border-dashed border-background-300 bg-background-50/40 text-sm font-medium text-foreground-500 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 lg:col-span-4"
          >
            <i className="ri-add-line text-lg" />
            加载更多往期追踪
          </button>
        </div>
      </div>
    </section>
  );
}